// extracted by mini-css-extract-plugin
export default {"datePickerClassName":"DateRange_datePickerClassName--bip","closeIconContainer":"DateRange_closeIconContainer--LNI","separator":"DateRange_separator--x8y"};